import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api.js';
import { useApp } from '../state.js';
import TopBar from '../ui/TopBar.js';

interface Task {
  id: string; title: string; kind: string; priority: number; due_date: string | null;
  project: string | null; assignee: string | null; status: string; page_id: string;
  rows: number[]; todoist_state: string | null; last_error: string | null;
  page_title: string | null; page_date: string | null;
}

export default function TasksView(): JSX.Element {
  const navigate = useNavigate();
  const showToast = useApp((s) => s.showToast);
  const [tasks, setTasks] = useState<Task[]>([]);
  const [state, setState] = useState<'all' | 'open' | 'completed'>('all');
  const [project, setProject] = useState('');

  const load = (): void => {
    const qs = new URLSearchParams({ state, ...(project ? { project } : {}) });
    void api.get<{ tasks: Task[] }>(`/api/tasks?${qs}`).then((r) => setTasks(r.tasks)).catch(() => setTasks([]));
  };
  useEffect(load, [state, project]);

  const projects = [...new Set(tasks.map((t) => t.project).filter((p): p is string => !!p))];
  const failed = tasks.filter((t) => t.status === 'send_failed');

  return (
    <>
      <TopBar title="Tarefas" back="/">
        <select value={state} onChange={(e) => setState(e.target.value as 'all')} style={{ width: 'auto' }}>
          <option value="all">Todas</option>
          <option value="open">Abertas</option>
          <option value="completed">Concluídas</option>
        </select>
        <select value={project} onChange={(e) => setProject(e.target.value)} style={{ width: 'auto' }}>
          <option value="">Todos os projetos</option>
          {projects.map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
      </TopBar>
      <div className="content stack">
        {failed.length ? (
          <div className="doubt row wrap">
            <span>{failed.length} tarefa(s) não foram para o Todoist.</span>
            <button onClick={() => { void api.post('/api/todoist/retry').then(() => { showToast('Reenviando…'); load(); }); }}>
              Tentar de novo agora
            </button>
          </div>
        ) : null}

        {tasks.map((t) => (
          <button key={t.id} className="card" onClick={() => navigate(`/p/${t.page_id}#L${t.rows?.[0] ?? 1}`)}>
            <div className="row wrap">
              <span className={`badge ${t.todoist_state === 'completed' ? 'ok' : t.status === 'send_failed' ? 'danger' : ''}`}>
                {t.todoist_state === 'completed' ? '✓ concluída' : t.status === 'send_failed' ? 'falhou' : 'aberta'}
              </span>
              {t.priority < 4 ? <span className="badge warn">P{t.priority}</span> : null}
              {t.project ? <span className="badge">{t.project}</span> : null}
              {t.assignee ? <span className="badge">@{t.assignee}</span> : null}
            </div>
            <h3 style={{ marginTop: 6 }}>{t.title}</h3>
            <p>
              {[t.due_date, t.page_title || t.page_date, t.rows?.length ? `linha ${t.rows[0]}` : '']
                .filter(Boolean).join(' · ')}
            </p>
            {t.last_error ? <p className="small" style={{ color: 'var(--danger)' }}>{t.last_error}</p> : null}
          </button>
        ))}
        {!tasks.length ? <p className="muted">Nada ainda. As tarefas criadas a partir do caderno aparecem aqui.</p> : null}
      </div>
    </>
  );
}
